import { AxiosRequestConfig, AxiosResponse } from "axios";
import HttpService from "./interface/HttpService";

class RoofTypeService {
  private instance: HttpService;
  private controllerName: string = 'roof-type'; 

  constructor() {
    this.instance = new HttpService(this.controllerName);
  }

  public get(url: string = '', config: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return this.instance.get(url, config);
  }

  public post(url: string = '', data: any, config: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return this.instance.post(url, data, config);
  }

  public put(url: string = '', data: any, config: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return this.instance.put(url, data, config);
  }

  public delete(url: string = '', config: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return this.instance.delete(url, config);
  }
}

export default RoofTypeService;